'use client';
import React from 'react';
import { Icon } from '@benzinga/core-ui';
import { Search } from '@benzinga/search-ui';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { Ticker } from '@benzinga/session';
import styled from '@benzinga/themetron';

export interface TickerSelectProps {
  error?: boolean;
  errorMessage?: string;
  onChange?: (value: Ticker | Ticker[] | null) => void;
  onRemove?: (value: Ticker | Ticker[] | null) => void;
  selected?: Ticker | Ticker[] | null;
  multiple?: boolean;
}

export const TickerSelect = ({ error, errorMessage, multiple, onChange, onRemove, selected }: TickerSelectProps) => {
  // const [open, setOpen] = React.useState(false);

  const handleChange = React.useCallback(
    (option: Ticker | null) => {
      if (typeof onChange === 'function') {
        onChange(option);
      }
      // setOpen(false);
    },
    [onChange],
  );

  const handleRemove = React.useCallback(
    (option: Ticker | null) => {
      if (typeof onRemove === 'function') {
        onRemove(option);
      }
    },
    [onRemove],
  );

  // const handleShow = React.useCallback(() => {
  //   setOpen(true);
  // }, [setOpen]);

  // const handleHide = React.useCallback(() => {
  //   setOpen(false);
  // }, [setOpen]);

  return (
    <Container>
      {selected && !multiple ? (
        <SelectedOption onRemove={handleRemove} selected={selected as Ticker} />
      ) : selected && multiple ? (
        // We want to display the selected tickers as SelectedOption components, but we also want to display the search bar
        <Search
          autoFocus={true}
          handleRemove={handleRemove}
          onSelect={handleChange}
          placeholder="Search Tickers..."
          searchType="ticker"
          selected={selected as Ticker[]}
          variant="box"
        />
      ) : (
        <Search
          autoFocus={true}
          onSelect={handleChange}
          placeholder="Search Tickers..."
          searchType="ticker"
          variant="box"
        />
      )}
      {error && errorMessage && <div className="error-message-text">{errorMessage}</div>}
    </Container>
  );

  // return (
  //   <Dropdown
  //     distance={0}
  //     onClose={handleHide}
  //     onOpen={handleShow}
  //     open={open}
  //     target={
  //       <Container className="ticker-select-dropdown-container">
  //         {selected ? (
  //           <SelectedOption onRemove={handleRemove} selected={selected} />
  //         ) : (

  //           <Button size="sm" variant={error ? 'danger' : 'flat'}>
  //             <Icon icon={plusCircle} />
  //             <span>Asset</span>
  //           </Button>
  //         )}

  //         {error && errorMessage && <div className="error-message-text">{errorMessage}</div>}
  //       </Container>
  //     }
  //   >
  //     <Search autoFocus={true} onSelect={handleChange} placeholder="Search Tickers..." searchType="ticker" variant="inline" />
  //   </Dropdown>
  // );
};

const SelectedOption = ({ onRemove, selected }: { onRemove: (value: Ticker | null) => void; selected: Ticker }) => (
  <div className="ticker-select-selected-option">
    <span>{selected?.symbol}</span>
    <div onClick={() => onRemove(selected)}>
      <Icon icon={faTimes} />
    </div>
  </div>
);

export const Container = styled.div`
  display: inline-flex;
  position: relative;

  /* group */
  .searchbar-wrapper.searchbar-box {
    border-radius: 4px;
    .search-icon {
      height: 26px;
      width: 32px;
    }
  }

  .ticker-select-selected-option {
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding-left: 0.5rem;
    padding-right: 0.25rem;
    background-color: ${({ theme }) => theme.colors.backgroundInactive};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 0.25rem;
    align-items: center;
    cursor: pointer;
    height: 1.75rem;
    display: inline-flex;

    > span:first-of-type {
      color: ${({ theme }) => theme.colors.foregroundInactive};
      font-weight: 700;
      font-size: 0.875rem;
      line-height: 1.25rem;
    }

    > div {
      display: flex;
      color: rgba(107, 114, 128, var(--tw-text-opacity));
      font-size: 0.75rem;
      line-height: 1rem;
      border-radius: 9999px;
      justify-content: center;
      align-items: center;
      width: 1.25rem;
      height: 1.25rem;
      margin-left: 5px;

      &:hover {
        background-color: ${({ theme }) => theme.colors.backgroundActive};
      }
    }
  }

  button {
    span:first-child {
      color: ${({ theme }) => theme.colorPalette.gray500};
      margin-right: 5px;
    }
  }

  .error-message-text {
    position: absolute;
    color: ${({ theme }) => theme.colorPalette.red500};
    background-color: ${({ theme }) => theme.colorPalette.red200};
    border: 1px solid ${({ theme }) => theme.colorPalette.red200};
    font-size: 0.75rem;
    line-height: 1rem;
    border-radius: 0.375rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    margin-top: 0.5rem;
    left: 0;
    top: 100%;
    min-width: 13rem;
    opacity: 0;
    pointer-events: none;

    &:hover {
      opacity: 1;
    }
  }
`;
